<template>
  <!-- Scan and Go Unavailable screen -->
  <div class="text-muted error-container">
    <h1>{{ $t('AcceleratedCheckOutFeatureUnavailable') }}</h1>
    <h2 class="mt-3">{{ $t('AcceleratedCheckOutFeatureUnavailableSubText') }}</h2>
    <router-link to="/" class="btn btn-outline-primary mt-3">{{ $t('returnHome') }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'ScanAndGoUnavailable',
};
</script>

<style lang="scss" scoped>
.error-container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}
</style>
